import { ActivatedRoute } from '@angular/router';
import { CommonCommunicationService } from './../services/common-communication.service';
import { Component, OnInit } from '@angular/core';
import { format } from 'date-fns';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { isEmpty, isNil } from 'lodash-es';
import edeliveryInfo from '../../assets/json/e-delivery.json';

@Component({
    standalone: false,
    selector: 'app-print-disclosure',
    templateUrl: './print-disclosure.component.html',
    styleUrls: ['./print-disclosure.component.scss'],
})
export class PrintDisclosureComponent implements OnInit {
    public dateTime;
    public logo = '../../assets/logos/CHUBB_Logo_Black_RBG.png';
    public getInitials: string;
    edeliveryContent: any;
    blobURL = environment.blobStorageBaseURL;
    emailaddress: string;

    constructor(
        public ccs: CommonCommunicationService,
        public aR: ActivatedRoute,
        private http: HttpClient
    ) {}

    ngOnInit() {
        this.emailaddress = sessionStorage.getItem('email');
        const ts = new Date().getTime();
        this.http
            .get<any>(this.blobURL + '/data/e-delivery.json?ts=' + ts, {
                responseType: 'json',
            })
            .subscribe((res) => {
                if (!isNil(res) && !isEmpty(res)) {
                    this.edeliveryContent = res;
                } else {
                    this.edeliveryContent = edeliveryInfo;
                }
            });

        this.getInitials = this.aR.snapshot.params.initials;
        const currentDate = new Date();
        this.dateTime = format(currentDate, 'MMMM dd, yyyy');
    }
}
